import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';


@Component({
  selector: 'app-date-picker',
  standalone: true,
  imports: [CommonModule, FormsModule, NzDatePickerModule],
  templateUrl: './date-picker.component.html',
  styleUrl: './date-picker.component.scss'
})
export class DatePickerComponent {
  @Input() label = '';
  @Input() error = '';
  @Output() returnValue: EventEmitter<any> = new EventEmitter<string>();
  date: string = '';
  onChange(result: Date): void {
      this.date = new Date(result)
          .toISOString()
          .slice(0, 10);
    this.returnValue.emit(this.date);
  }
}
